import { useMutation } from 'react-query';

import { CreateRelativityListRequestDto } from '../../../../backend/src/integrations/relativity/dto/create-list-request.dto';
import {
  CreateRelativityListError,
  CreateRelativityListErrorBody,
} from '../../../../backend/src/integrations/relativity/relativity-errors';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface CreateRelativityListResponse {
  artifactId: number;
  listName: string;
  skippedDuplicates: number;
}

type CreateRelativityListVariables = CreateRelativityListRequestDto & { workspaceId: number };

const useCreateRelativityList = () => {
  const { getFetchConfig } = useGetFetchConfig();

  return useMutation<CreateRelativityListResponse, CreateRelativityListError, CreateRelativityListVariables>(
    async ({ workspaceId, matterId, listName, docIds }) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.POST,
        data: { matterId, listName, docIds },
      });

      let response: Response;

      // I think we have to do this here because we're returning this special error shape
      try {
        response = await fetch(`${APIBaseChronos}/api/relativity/workspaces/${workspaceId}/lists`, fetchConfig);
      } catch {
        throw new CreateRelativityListError(0, {
          message: "Couldn't reach the server. Check your connection and try again.",
        });
      }

      if (!response.ok) {
        const body = (await response.json().catch(() => null)) as CreateRelativityListErrorBody | null;
        throw new CreateRelativityListError(response.status, {
          message: body?.message ?? `Failed to create list (${response.status})`,
          ...(body ?? {}),
        });
      }

      return response.json();
    },
  );
};

export default useCreateRelativityList;
